module.exports = __webpack_public_path__ + "static/media/hashtag-nft-1.c224c0bf.jpg";